import { configureStore } from "@reduxjs/toolkit";
import counterSlice from "./auth/authSlice";
import RequestsSlice from "./auth/RequestsAuthSlice";
import plmHubReducer from "./plmHub/plmHubSlice";
import googleDriveReducer from "./googleDrive/googleDriveSlice";
import dreamMachineReducer, { DREAM_MACHINE_STORAGE_KEY } from "./dreamMachine/dreamMachineSlice";

// T-03: explicitly gate Redux DevTools to non-production. RTK defaults to
// this already, but being explicit documents intent and protects against
// tooling changes that might flip the default.
export const store = configureStore({
  reducer: {
    counter: counterSlice,
    request: RequestsSlice,
    dreamMachine: dreamMachineReducer,
    plmHub: plmHubReducer,
    googleDrive: googleDriveReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

store.subscribe(() => {
  const dreamMachine = store.getState().dreamMachine;
  const persistedDreamMachine = {
    spark: {
      dreamId: dreamMachine.spark.dreamId,
      dreamType: dreamMachine.spark.dreamType,
      selectedSuggestion: dreamMachine.spark.selectedSuggestion,
      promptText: dreamMachine.spark.promptText,
      response: dreamMachine.spark.response,
    },
    blueprint: {
      selectedDreamType: dreamMachine.blueprint.selectedDreamType,
      data: dreamMachine.blueprint.data,
    },
    vow: {
      data: dreamMachine.vow.data,
    },
    garden: {
      data: dreamMachine.garden.data,
      pagination: dreamMachine.garden.pagination,
    },
    details: {
      byId: dreamMachine.details.byId,
      current: dreamMachine.details.current,
    },
  };

  try {
    localStorage.setItem(DREAM_MACHINE_STORAGE_KEY, JSON.stringify(persistedDreamMachine));
  } catch {
    // Persistence is best-effort; the live Redux state still drives the UI.
  }
});
